import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from './redux/store';
import App from './App';

import '@styles/generic.scss';
import '@styles/main.scss';

import { initApi } from '@utils/api';

import config from './config';

const { API_URL } = config;

initApi(API_URL);

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <App />
        </Provider>
    </Router>,
    document.getElementById('root'),
);
